import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { CalendarException, CalendarExceptionList } from 'src/app/model/calendar-exception';
import * as CalendarActions from 'src/app/store/calendar/calendar.actions';
import { Observable, Subscription, map } from 'rxjs';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { selectExceptions } from 'src/app/store/calendar/calendar.selector';
import { TranslateService } from '@ngx-translate/core';
import { StandardDesignParameters } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-exceptions-calendar-card',
	templateUrl: './exceptions-calendar-card.component.html',
	providers: [],
})

export class ExceptionCalendarCardComponent implements OnInit, OnDestroy, OnChanges {
	@Input() calendarId: number;
	@Input() edit: boolean;

	exceptions$: Observable<CalendarException[] | undefined>;
	exceptionsSub: Subscription | undefined;

	exceptions: CalendarException[];

	dateForm: FormControl = new FormControl([]);

	datesSub: Subscription | undefined;
	dateFormSub: Subscription;

	exceptionsList: CalendarExceptionList[];
	dates: Date[] | undefined;

	datesCompare: Date[];

	monthArray: string[];
	monthLabel: string;
	minDate: Date = new Date();
	dateSelect: Date = new Date();
	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();
		this.onResize();

	}

	initSelectors(): void {
		// Store selectors
		this.exceptions$ = this.store.select(selectExceptions);
	}

	ngOnChanges(): void {
		this.subscribeAll();
	}

	subscribeAll(): void {
		this.exceptionsSub = this.exceptions$.pipe(
			map((exceptions) => exceptions.filter((e) => e.CalendarId === this.calendarId)),
			map(exceptions => exceptions.sort((b, a) => new Date(a.Date).valueOf() - new Date(b.Date).valueOf()))
		)
			.subscribe((exceptions) => {
				this.exceptions = exceptions;
				this.generateExceptions();
				//this.minDate = new Date();
			});
	}

	ngOnDestroy(): void {
		this.exceptionsSub?.unsubscribe();
	}

	generateExceptions(): void {
		let cont = 0;
		this.exceptionsList = [];
		this.dates = [];
		for (const exception of this.exceptions) {
			const dateExceMom = moment(exception.Date.split("T")[0], 'YYYY-MM-DD');
			const dateMom = moment();
			dateMom.set('year', dateExceMom.get('year'));
			dateMom.set('month', dateExceMom.get('month'));
			dateMom.set('date', dateExceMom.get('date'));
			this.dates.push(dateMom.toDate());
			exception.DateMom = dateMom.toDate();
			const keyStr = dateMom.toDate().getFullYear() + '---' + dateMom.toDate().getMonth();
			if (this.exceptionsList.length === 0 || this.exceptionsList[cont - 1].DateStr !== keyStr) {
				//const exce = { Date: new Date(exception.Date), DateStr: keyStr, ListException: [] };
				const exce = { Date: dateMom.toDate(), DateStr: keyStr, ListException: [] };
				this.exceptionsList.push(exce);
				cont++;
			}
			this.exceptionsList[cont - 1].ListException.push(exception);
		}
		this.datesCompare = Object.assign([], this.dates);
		this.dateForm = new FormControl(this.dates);
		this.dateFormSub = this.dateForm.valueChanges.subscribe(value => {
			if (value !== null) {
				const missingAdd = value.filter(item => this.dates.indexOf(item) < 0);
				if (missingAdd.length > 0) {
					const date = moment(missingAdd[0]).format('YYYY-MM-DDT00:00:00') + 'Z';
					this.dateSelect = moment(missingAdd[0]).toDate();
					const newException: CalendarException = {
						CalendarId: this.calendarId,
						Date: date
					};
					this.store.dispatch(CalendarActions.addException({ exception: newException }));
				}
				const missingRemove = this.dates.filter(item => value.indexOf(item) < 0);
				if (missingRemove.length > 0) {
					const date = moment(missingRemove[0]).format('YYYY-MM-DDT00:00:00') + 'Z';
					this.dateSelect = moment(missingAdd[0]).toDate();
					const exception = this.exceptions.find(e => e.Date === date);
					this.store.dispatch(CalendarActions.deleteException({ exceptionId: exception.Id }));
				}
			} else if (this.dates !== null && this.dates !== undefined && this.dates.length > 0) {
				const missingRemove = this.dates[0];
				const date = moment(missingRemove).format('YYYY-MM-DDT00:00:00') + 'Z';
				const exception = this.exceptions.find(e => e.Date === date);
				this.store.dispatch(CalendarActions.deleteException({ exceptionId: exception.Id }));
			}
		});
		setTimeout(() => {
			this.minDate = this.dateSelect;
		}, 200);

	}

	calculateMonthLabel(): string[] {
		const monthsArray = [];
		this.exceptions.forEach((exception) => {
			//let dateSplited: String[];
			const allDate = exception.Date.substring(0, 7);
			//dateSplited = allDate.split('-');
			if (!monthsArray.includes(allDate)) {
				monthsArray.push(allDate);
			}
			//finalStr = dateSplited[0] + ', ' + dateSplited[1];
		});
		return monthsArray;
	}

	getMonthLabel(exception: CalendarException): string {
		const dateInput = exception.Date.substring(0, 7);
		if (this.monthArray.includes(dateInput)) {
			this.monthArray.splice(0, 1);
			return dateInput;
		}
		return '';
	}

	updateCalendar(exceptionDateSelected: CalendarException): void {
		this.store.dispatch(CalendarActions.deleteException({ exceptionId: exceptionDateSelected.Id }));
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	colResponsive(position: string): string {
		if (this.screenWidth <= StandardDesignParameters.MAX_MD_WIDTH) {
			return "col-12";
		} else if (position === "left") {
			return "col-8";
		} else {
			return "col-4";
		}
	}
}
